var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleTickOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5749 6.117C17.9838 6.35562 18.1218 6.88049 17.8832 7.28934L12.3809 16.7169C12.3808 16.7171 12.3807 16.7172 12.3806 16.7174C12.2568 16.93 12.0887 17.1135 11.8877 17.2554C11.6881 17.3962 11.4608 17.4928 11.2209 17.5387C10.9779 17.5868 10.7274 17.5806 10.4871 17.5205C10.2472 17.4605 10.0235 17.3483 9.83205 17.192L6.32172 14.3837C5.95207 14.088 5.89214 13.5486 6.18786 13.179C6.48358 12.8093 7.02297 12.7494 7.39263 13.0451L10.9009 15.8518L16.4026 6.42523C16.6412 6.01638 17.1661 5.87838 17.5749 6.117Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.71429C6.31936 1.71429 1.71429 6.31936 1.71429 12C1.71429 17.6806 6.31936 22.2857 12 22.2857C17.6806 22.2857 22.2857 17.6806 22.2857 12C22.2857 6.31936 17.6806 1.71429 12 1.71429ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTickOutline);
export default __webpack_public_path__ + "static/media/circle-tick-outline.5dee5f71e465d3e2bd2215e78a6e8f48.svg";
export { ForwardRef as ReactComponent };